import { Alert, Button, Col, Form as AntdForm, Input, Row, Typography } from 'antd';
import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../context/auth';
import { login, password } from '../../../../utils/inputRules';
import styles from '../index.module.less';
import { EMAIL_NOT_VERIFIED_STATUS_CODE } from '../../../../utils/statusCodes';
import { setDataInStorage } from '../../../../utils/storage';
import { useContextUsers } from '../../../../context/users';

function SignIn(): JSX.Element {
  const navigate = useNavigate();
  const { authorized, signIn, loading, error, clearResponseError } = useAuth();
  const { setProfile } = useContextUsers();

  useEffect(() => {
    if (authorized) {
      navigate('/home', { replace: true });
    }
  }, [authorized]);

  useEffect(() => {
    clearResponseError();
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.keyCode === 32) {
      e.preventDefault();
    }
  };

  const handleSignIn = async (values: { email: string; password: string }) => {
    signIn(values)
      .then((res) => {
        // @ts-ignore res?.data?.user
        const user = res?.data?.user;

        if (user) setProfile?.(user);
      }).catch((err) => {
        if (err?.response?.status === EMAIL_NOT_VERIFIED_STATUS_CODE) {

        setDataInStorage('auth', {
          email: values.email,
        })

        navigate('/email-verification', { replace: true });
      }
    })
  }

  return (
    <AntdForm
      layout="vertical"
      onFinish={handleSignIn}
      className={styles.form}
      autoComplete="off"
      style={{ padding: '0 12px', overflowY: 'auto' }}
    >
      {error ? (
        <AntdForm.Item>
          <Alert onClose={clearResponseError} message={error} type="error" closable showIcon />
        </AntdForm.Item>
      ) : null}
      <AntdForm.Item name="email" label="Email" rules={login}>
        <Input size="large" placeholder="Enter Email" autoFocus onKeyDown={handleKeyDown} />
      </AntdForm.Item>
      <AntdForm.Item name="password" label="Password" rules={password} hasFeedback>
        <Input.Password size="large" placeholder="Enter Password" onKeyDown={handleKeyDown} />
      </AntdForm.Item>
      <AntdForm.Item>
        <div className={styles.textBox}>
          <Typography.Text className="color-gray">
            <Link to="/forgot-password">Forgot Password?</Link>
          </Typography.Text>
        </div>
      </AntdForm.Item>
      <AntdForm.Item shouldUpdate>
        {({ getFieldsValue, getFieldsError }) => {
          const { email, password: passwordValue } = getFieldsValue();
          const formIsComplete = email && passwordValue && getFieldsError().every((field) => !field.errors.length);

          return (
            <Row gutter={24}>
              <Col span={24}>
                <Button
                  size="large"
                  type="primary"
                  htmlType="submit"
                  block
                  loading={loading}
                  disabled={!formIsComplete}
                >
                  Sign In
                </Button>
              </Col>
            </Row>
          );
        }}
      </AntdForm.Item>
      <div className={styles.textBox}>
        <Typography.Text className="color-gray">
          Don't have an account? <Link to="/sign-up">Sign Up</Link>
        </Typography.Text>
      </div>
    </AntdForm>
  );
}

export default SignIn;
